import React, {
  useState,
  MouseEventHandler,
  useContext,
  useEffect,
} from 'react';
import inspectionTemplateApi from '../../utils/api/inspectionTemplate';
import inspectionTemplateTypesApi, { InspectionTemplateType } from '../../utils/api/inspectionTemplateTypes';
import InspectionTemplateDetailsForm from './Forms/InspectionTemplateDetailsForm';
import AppDivisionContext from '../../contexts/AppDivisionContext';
import { Redirect } from 'react-router-dom';
import { Tenant } from '../../utils/api/tenant';

export interface IInspectionTemplateAddProps {
  handleClose: MouseEventHandler;
  show?: boolean;
  enableRedirect?: boolean;
  tenants?: Tenant[];
}

const InspectionTemplateAdd: React.FC<IInspectionTemplateAddProps> = ({
  handleClose,
  show = true,
  enableRedirect = true,
}) => {
  const { appDivisionId } = useContext(AppDivisionContext);
  const [redirectId, setRedirectId] = useState(0);
  const [inspectionTypes, setInspectionTypes] = useState<InspectionTemplateType[]>([]);
  const [isLoadingTypes, setIsLoadingTypes] = useState<boolean>(true);

  useEffect(() => {
    setIsLoadingTypes(true);
    inspectionTemplateTypesApi
      .index()
      .then((data) => {
        setInspectionTypes(data);
        setIsLoadingTypes(false);
      })
      .catch((error) => {
        console.error('Error fetching inspection template types:', error);
        setIsLoadingTypes(false);
      });
  }, []);

  const handleSubmit = (formState: any) => {
    return inspectionTemplateApi
      .create(formState)
      .then((data) => {
        if (enableRedirect) {
          setRedirectId(data.id);
        }

        return Promise.resolve();
      })
      .catch(() => console.error('Error creating Inspection Template'));
  };

  if (Boolean(redirectId)) {
    return (
      <Redirect
        to={`/divisions/${appDivisionId}/inspection-templates/${redirectId}`}
        push
      />
    );
  }

  if (show && isLoadingTypes) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        Loading inspection types...
      </div>
    );
  }

  if (show && !isLoadingTypes) {
    return (
      <InspectionTemplateDetailsForm
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        title='Add an Inspection Template'
        inspectionTemplate={{ divisionId: appDivisionId }}
        inspectionTypes={inspectionTypes}
      />
    );
  }

  return null;
};

export default InspectionTemplateAdd;
